
import { Component, Vue } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
import { getTotal, getOperation, getIndexMapData } from "@/api/main";
import LineChart from "@/components/Charts/LineChart.vue";
import PieChart from "@/components/Charts/PieChart.vue";
import BaiduMap from "@/components/Map/index.vue";

@Component({
  name: "Dashboard",
  components: {
    LineChart,
    BaiduMap,
    PieChart,
  },
})
export default class extends Vue {
  private totalData = {};
  private operationData = [];
  private mapData = [];
  private dataItem = {
    name: "设备数",
    xAxis: [
      "13:00",
      "13:05",
      "13:10",
      "13:15",
      "13:20",
      "13:25",
      "13:30",
      "13:35",
      "13:40",
      "13:45",
      "13:50",
      "13:55",
    ],
    data: [120, 110, 125, 145, 122, 165, 122, 220, 182, 191, 134, 150],
  };
  get name() {
    return UserModule.username;
  }
  get logintime() {
    return UserModule.logintime;
  }
  private async getMapData() {
    const { data } = await getIndexMapData({});
    this.mapData = data;
  }
  private async getTotalData() {
    const { data } = await getTotal({});
    this.totalData = data;
  }
  private async getOperation() {
    const { data } = await getOperation({
      page: 1,
      pagesize: 4,
    });
    this.operationData = data.items;
  }
  created() {
    this.getMapData();
    this.getTotalData();
    this.getOperation();
  }
}
